import { useCallback } from 'react'

import { sortFieldsByOrder as sortFieldsByOrderUtils } from 'features/fields/utils'

export const sortFieldsByOrder = (
    fields: FieldDto[] | undefined,
    object?: ObjectDto | undefined,
    _apiNameKey: string = 'api_name'
) => {
    return sortFieldsByOrderUtils(fields ?? [], object)
}

export const useSortingByFieldsOrder = (object?: ObjectDto) => {
    return useCallback(
        (fields: FieldDto[], apiNameKey: string = 'api_name') =>
            sortFieldsByOrder(fields, object, apiNameKey),
        [object]
    )
}
